import { render, staticRenderFns } from "./NewQuoteSidebar.vue?vue&type=template&id=fb886186&scoped=true&"
import script from "./NewQuoteSidebar.vue?vue&type=script&lang=js&"
export * from "./NewQuoteSidebar.vue?vue&type=script&lang=js&"
import style0 from "./NewQuoteSidebar.vue?vue&type=style&index=0&id=fb886186&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb886186",
  null
  
)

export default component.exports